import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row container-fluid mt-2 d-flex w-100"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<hr><div class=\"col-md-12\"><strong>Details de livraison</strong></div><div class=\"col-md-4\"><div class=\"mt-2\"><label class=\"tx-11 fw-bolder mb-0 text-uppercase text-primary\">Type de la commande</label><p class=\"\">Livraison</p></div></div>", 3)
const _hoisted_5 = { class: "col-md-4" }
const _hoisted_6 = { class: "mt-2" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "tx-11 fw-bolder mb-0 text-uppercase text-primary" }, "Adresse de livraison:", -1)
const _hoisted_8 = { class: "" }
const _hoisted_9 = { class: "col-md-4" }
const _hoisted_10 = { class: "mt-2" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "tx-11 fw-bolder mb-0 text-uppercase text-primary" }, "Téléphone pour la livraison:", -1)
const _hoisted_12 = { class: "" }
const _hoisted_13 = {
  key: 1,
  class: "row container-fluid mt-2 d-flex w-100"
}
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<hr><div class=\"col-md-12\"><strong>Details de livraison</strong></div><div class=\"col-md-6\"><div class=\"mt-2\"><label class=\"tx-11 fw-bolder mb-0 text-uppercase text-primary\">Type de la commande</label><p class=\"\">Emporter</p></div></div>", 3)
const _hoisted_17 = {
  key: 0,
  class: "col-md-6"
}
const _hoisted_18 = { class: "mt-2" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "tx-11 fw-bolder mb-0 text-uppercase text-primary" }, "Adresse de collect:", -1)
const _hoisted_20 = { class: "" }
const _hoisted_21 = {
  key: 2,
  class: "row container-fluid mt-2 d-flex w-100"
}
const _hoisted_22 = /*#__PURE__*/_createStaticVNode("<hr><div class=\"col-md-12\"><strong>Details de livraison</strong></div><div class=\"col-md-6\"><div class=\"mt-2\"><label class=\"tx-11 fw-bolder mb-0 text-uppercase text-primary\">Type de la commande</label><p class=\"\">Sur place </p></div></div>", 3)
const _hoisted_25 = { class: "col-md-6" }
const _hoisted_26 = { class: "mt-2" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", { class: "tx-11 fw-bolder mb-0 text-uppercase text-primary" }, " N° de la table", -1)
const _hoisted_28 = { class: "" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.order?.customerstore && _ctx.order?.type == 'liv')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.order?.deliveryaddress?.address), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.order?.deliveryaddress?.phone), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.order?.type == 'cac')
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _hoisted_14,
          (_ctx.order?.type == 'cac')
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.order?.cacaddress?.address), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.order?.type == 'at_place')
      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
          _hoisted_22,
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _hoisted_27,
              _createElementVNode("p", _hoisted_28, _toDisplayString(_ctx.order?.table?.table_number), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}